<template>
  <el-select filterable :disabled="disabled" class="select-corp" size="mini" @change="changeCode" v-model="id" placeholder="选择商品">
    <el-option style="color:red" label="+新增" value="add"></el-option>
    <el-option
      v-for="item in list"
      :key="item.id"
      :label="'*' + item.name2 + '*' + item.name + item.spec"
      :value="item.id"
    >
    </el-option>
  </el-select>
  <add-goods @success="addSuccess" ref="addGood"></add-goods>
</template>
<script>
// <invoice-type v-model:code="temp.fplx"></invoice-type>
import { getGoodList } from "@/api/ea";
export default {
  name: 'goodsComponent',
  props: {
    disabled: false,
    id: "",
  },
  data() {
    return {
      listQuery: {
        comId: this.$store.getters['user/comInfo'].id*1,
      },
      list: [],
    }
  },
  created () {
    this.getList()
  },
  methods: {
    addSuccess(e){
      this.getList()
      this.$emit('update:id', e.id)
      this.$emit('update:name', e.name)
      this.$emit('success', e)
    },
    changeCode(){
      if(this.id == 'add'){
        this.$refs.addGood.form = {
          yh_status:'0',
          hsbz:'0',
          mrsp:'0',
          mslx: '',
        }
        this.$refs.addGood.dialogVisible = true
        //清空
        this.$emit('update:id', "")
        this.$emit('update:name', "")
        this.$emit('success', {})
        return
      }
      let infos = this.list.filter(v=>{return this.id == v.id})
      if(infos.length == 1){
        this.$emit('update:id', this.id)
        this.$emit('update:name', infos[0].name)
        this.$emit('success', infos[0])
      }
    },
    getList(){
      getGoodList(this.listQuery).then(res=>{
        if(res.data.data.list){
          this.list = res.data.data.list
        }
      })
    },
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.select-corp{
  width: 100%;
}
</style>
